export { detectTerminal as default } from './src/details';
export * from './src/index';
